import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';
import GlobalStyle from './styles/GlobalStyle';

import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/layout/ScrollToTop';

import Home from './pages/Home';
import About from './pages/About';
import History from './pages/History';
import Organization from './pages/Organization';
import Location from './pages/Location';
import Certifications from './pages/Certifications';
import BusinessInterior from './pages/BusinessInterior';
import BusinessLandscape from './pages/BusinessLandscape';
import BusinessManagement from './pages/BusinessManagement';
import BusinessMetal from './pages/BusinessMetal';
import BusinessFinishing from './pages/BusinessFinishing';
import BusinessPavement from './pages/BusinessPavement';
import BusinessTank from './pages/BusinessTank';
import BusinessDisinfection from './pages/BusinessDisinfection';
import SocialEnterprise from './pages/SocialEnterprise';
import WomenEnterprise from './pages/WomenEnterprise';
import NoticeList from './pages/NoticeList';
import NoticeDetail from './pages/NoticeDetail';
import Inquiry from './pages/Inquiry';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Router>
        <ScrollToTop />
        <Header />
        <main style={{ minHeight: '80vh' }}>
          <Routes>
            {/* 메인 */}
            <Route path="/" element={<Home />} />

            {/* 회사소개 */}
            <Route path="/about" element={<About />} />
            <Route path="/about/history" element={<History />} />
            <Route path="/about/organization" element={<Organization />} />
            <Route path="/about/location" element={<Location />} />
            <Route path="/about/certifications" element={<Certifications />} />

            {/* 사업영역 */}
            <Route path="/business" element={<BusinessInterior />} />
            <Route path="/business/interior" element={<BusinessInterior />} />
            <Route path="/business/landscape" element={<BusinessLandscape />} />
            <Route path="/business/management" element={<BusinessManagement />} />
            <Route path="/business/metal" element={<BusinessMetal />} />
            <Route path="/business/finishing" element={<BusinessFinishing />} />
            <Route path="/business/pavement" element={<BusinessPavement />} />
            <Route path="/business/tank" element={<BusinessTank />} />
            <Route path="/business/disinfection" element={<BusinessDisinfection />} />

            {/* 홍보센터 */}
            <Route path="/promotion" element={<SocialEnterprise />} />
            <Route path="/promotion/social" element={<SocialEnterprise />} />
            <Route path="/promotion/women" element={<WomenEnterprise />} />

            {/* 고객센터 */}
            <Route path="/notices" element={<NoticeList />} />
            <Route path="/notices/:noticeId" element={<NoticeDetail />} />
            <Route path="/inquiry" element={<Inquiry />} />
          </Routes>
        </main>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;
